import { UPDATE_FEEDBACK_STATUS } from '../constants';
import c from './admin-note.module.scss';
import { Card, Icon, IconButton } from '@monash/portal-react';

const AdminNote = ({
  message,
  author,
  time,
  onDelete,
  onClick,
  feedbackItem,
  isResolved,
}) => {
  return (
    <div className={`${isResolved ? c.resolvedNote : c.adminNote}`}>
      <Card className={c.card}>
        <div className={c.message} onClick={isResolved ? undefined : onClick}>
          {message}
        </div>

        <div className={c.bottomStrip}>
          By: {author} at {time}
          {feedbackItem.status !== UPDATE_FEEDBACK_STATUS.RESOLVED && (
            <IconButton
              icon={Icon.Trash}
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            />
          )}
        </div>
      </Card>
    </div>
  );
};

export default AdminNote;
